const ButtonStyle = {
  base: "cursor-pointer font-sans",
  btn: "block text-center font-semibold rounded-control px-12 py-3 ease-in-out duration-500",
  big: "md:text-lg",
  small: "text-sm px-7",
  smaller: "text-xs px-4",
  outline:
    "text-btn-outline-text border-solid border border-btn-outline-border hover:text-btn-outline-hover-text hover:border-btn-outline-hover-border hover:bg-btn-outline-hover-bg bg-transparent",
  green: "bg-btn-primary hover:bg-btn-primary-hover text-white",
  red: "bg-btn-danger hover:bg-btn-danger-hover hover:border-btn-danger text-white",
  blue: "bg-btn-blue hover:bg-btn-blue-hover hover:border-btn-blue-hover text-white",
  orange: "bg-btn-orange hover:bg-btn-orange-hover hover:border-btn-orange-hover text-white",
  textOnly: "text-btn-text",
  iconButton: "inline-block p-0 w-4 h-4",
  iconText: "pl-11",
  iconTextOnly: "pl-6",
  fullWidth: "!w-full",
  rounded: "rounded-full",
  relative: "relative",
  absolute: "absolute",
  alignLeft: "pl-6 pr-0",
  alignRight: "pl-0 pr-6",
  loading: `relative after:absolute after:w-4 after:h-4 after:right-1 after:top-4 after:z-10 
    after:bg-[url('components/button/icons/ico-loader.svg')] after:bg-contain after:right-3 after:origin-center after:animate-loading`,
};

export default ButtonStyle;
